import { gql } from "@apollo/client";

const resetOrderVendorAssignmentForInHouseShippingMutation = gql`
  mutation($orderId: ID!) {
    resetOrderVendorAssignmentForInHouseShipping(orderId: $orderId) {
      succeeded
    }
  }
`;

export default resetOrderVendorAssignmentForInHouseShippingMutation;
